"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = exports.isFloat = exports.isNumber = exports.isArrayEquals = exports.numberFormat = exports.integerRound = exports.IntegerRound = exports.getWeekDayName = exports.randomInteger = exports.JSON = void 0;
const bignumber_js_1 = require("bignumber.js");
var json_1 = require("./json");
Object.defineProperty(exports, "JSON", { enumerable: true, get: function () { return __importDefault(json_1).default; } });
/**
 * Generates random integer from min to max includes.
 * @param min min integer
 * @param max max integer
 * @returns random integer
 */
function randomInteger(min, max) {
    return Math.floor(min + Math.random() * (max + 1 - min)); // случайное число от min до max включительно
}
exports.randomInteger = randomInteger;
function getWeekDayName(day) {
    if (day === 0)
        return 'понедельник';
    else if (day === 1)
        return 'вторник';
    else if (day === 2)
        return 'среда';
    else if (day === 3)
        return 'четверг';
    else if (day === 4)
        return 'пятница';
    else if (day === 5)
        return 'суббота';
    else if (day === 6)
        return 'воскресенье';
}
exports.getWeekDayName = getWeekDayName;
var IntegerRound;
(function (IntegerRound) {
    /**
     * Returns the integral part of the a numeric expression,
     * removing any fractional digits. If `integer` is already an integer,
     * the result is `integer`.
     * ```
     * integerRound (123.456, IntegerRound.None, 2) // 123.45
     * ```
     */
    IntegerRound[IntegerRound["None"] = 0] = "None";
    /**
     * Returns a supplied numeric expression rounded to the nearest integer.
     * ```
     * integerRound (123.456, IntegerRound.Round, 2) // 123.46
     * integerRound (123.454, IntegerRound.Round, 2) // 123.45
     * ```
     */
    IntegerRound[IntegerRound["Round"] = 1] = "Round";
    /**
     * Returns the smallest integer greater than or equal to its numeric argument.
     * ```
     * integerRound (123.456, IntegerRound.Ceil, 2) // 123.46
     * ```
     */
    IntegerRound[IntegerRound["Ceil"] = 2] = "Ceil";
    /**
     * Returns the greatest integer less than or equal to its numeric argument.
     * ```
     * integerRound (123.456, IntegerRound.Floor, 2) // 123.45
     * ```
     */
    IntegerRound[IntegerRound["Floor"] = 3] = "Floor";
})(IntegerRound = exports.IntegerRound || (exports.IntegerRound = {}));
function integerRound(integer, type = IntegerRound.None, decimals = 0) {
    const divisor = Math.pow(10, decimals);
    const _integer = new bignumber_js_1.BigNumber(integer).multipliedBy(divisor).toNumber();
    if (type === IntegerRound.None)
        return Math.trunc(_integer) / divisor;
    else if (type === IntegerRound.Round)
        return Math.round(_integer) / divisor;
    else if (type === IntegerRound.Ceil)
        return Math.ceil(_integer) / divisor;
    return Math.floor(_integer) / divisor;
}
exports.integerRound = integerRound;
function numberFormat(amount, decimalCount = 2, decimal = '.', thousands = ',') {
    const negativeSign = amount < 0 ? '-' : '';
    const i = integerRound(Math.abs(amount), IntegerRound.None, 0).toString();
    const j = i.length > 3 ? i.length % 3 : 0;
    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? (decimal + new bignumber_js_1.BigNumber(integerRound(amount, IntegerRound.None, decimalCount)).minus(+i).toString().slice(2).padEnd(decimalCount, '0')) : '');
}
exports.numberFormat = numberFormat;
function isArrayEquals(array, array2) {
    if (array.length === array2.length) {
        for (const [i, value] of array.entries()) {
            if (array2[i] !== value)
                return false;
        }
        return true;
    }
    return false;
}
exports.isArrayEquals = isArrayEquals;
function isNumber(value) {
    return typeof value === 'number' && !isNaN(value) && (value % 1 === 0);
}
exports.isNumber = isNumber;
function isFloat(value) {
    return typeof value === 'number' && !isNaN(value) && (value % 1 !== 0);
}
exports.isFloat = isFloat;
function isObject(value) {
    return (!!value) && (value.constructor === Object);
}
exports.isObject = isObject;
